import Accordion from "@/components/Accordion";
import React from "react";
import TextInput from "../../TextInput";
import { LanguageConfigModel } from "@/pages/Messaging/types";
import { ChatWindow } from "../../types";

interface Props {
  onExpanded(): void;
  workingChatWindow: ChatWindow;
  setWorkingChatWindow: (chatWindow: ChatWindow) => void;
}

export function Messenger(props: Props) {
  const workingLanguageConfig = props.workingChatWindow.languageConfig || {};

  const updateLanguageConfig = (updates: Partial<LanguageConfigModel>) => {
    props.setWorkingChatWindow({
      ...props.workingChatWindow,
      languageConfig: {
        ...workingLanguageConfig,
        ...updates
      }
    });
  };

  return (
    <Accordion.Item eventKey="messenger" onExpanded={() => props.onExpanded()}>
      <Accordion.Header>
        <Accordion.Title>Messenger</Accordion.Title>
      </Accordion.Header>
      <Accordion.Body>
        <div className="mb-2">
          <div className="text-sm font-medium mb-2">Header Title</div>
          <TextInput
            value={workingLanguageConfig.facebookTitle}
            setValue={(value) => updateLanguageConfig({ facebookTitle: value })}
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Header Sub Title</div>
          <TextInput
            value={workingLanguageConfig.facebookSubTitle}
            setValue={(value) =>
              updateLanguageConfig({ facebookSubTitle: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Response Time Message</div>
          <TextInput
            value={workingLanguageConfig.facebookResponseTime}
            setValue={(value) =>
              updateLanguageConfig({ facebookResponseTime: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Form Header</div>
          <TextInput
            value={workingLanguageConfig.facebookFormHeader}
            setValue={(value) =>
              updateLanguageConfig({ facebookFormHeader: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Form Footer</div>
          <TextInput
            value={workingLanguageConfig.facebookFormFooter}
            setValue={(value) =>
              updateLanguageConfig({ facebookFormFooter: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
          <div className="text-sm font-medium my-2">Button Message</div>
          <TextInput
            value={workingLanguageConfig.facebookButton}
            setValue={(value) =>
              updateLanguageConfig({ facebookButton: value })
            }
            showEmojiButton={false}
            maxWordCount={undefined}
          />
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
